/** @format */

import { Link, type LinkProps } from 'react-router-dom';
import { type MouseEvent } from 'react';
import { API_URL } from 'src/constants';
import getRedirectionLink, { toSameOriginPath } from 'src/utils/helper';

const preventFocusScroll = (event: MouseEvent<HTMLAnchorElement>) => {
  if (event.button !== 0) return;
  event.preventDefault();
};

const InternalLink = ({ to, children }: { to: LinkProps['to']; children: string }) => (
  <Link to={to} onMouseDown={preventFocusScroll}>
    {children}
  </Link>
);

const internalPathOf = (link?: string): string | null => {
  const path = toSameOriginPath(link);
  if (typeof path !== 'string' || !path.startsWith('/') || path.startsWith('//')) return null;
  return path;
};

export function LinkWidget({ data }) {
  const image = API_URL + data.image;
  const openInNewTab = data.linkTarget === '_blank';
  const internalPath = openInNewTab ? null : internalPathOf(data.link);

  return (
    <div
      className={`link-widget ${data.highlight ? 'link-widget--highlight' : ''}`}
      data-width={data.w}
      data-height={data.h}>
      <div className="link-widget--list-item">
        <div className="link-widget--list-item-image">
          <img src={image} alt={data.title} />
          {data.category && <div className="link-widget--list-item-category">{data.category}</div>}
        </div>
        <div className="link-widget--list-item-title">{data.title}</div>
        <div className="link-widget--list-item-text">{data.content}</div>
        <div className="link-widget--list-item-link">
          {internalPath ? (
            <InternalLink to={internalPath}>{data.linkTitle}</InternalLink>
          ) : data.link ? (
            <a
              href={data.link}
              target={openInNewTab ? '_blank' : undefined}
              rel={openInNewTab ? 'noopener noreferrer' : undefined}
              onMouseDown={preventFocusScroll}>
              {data.linkTitle}
            </a>
          ) : (
            <InternalLink to={getRedirectionLink(data)}>{data.linkTitle}</InternalLink>
          )}
        </div>
      </div>
    </div>
  );
}
